import { render, staticRenderFns } from "./AddGoods.vue?vue&type=template&id=f7c6b168&scoped=true&"
import script from "./AddGoods.vue?vue&type=script&lang=js&"
export * from "./AddGoods.vue?vue&type=script&lang=js&"
import style0 from "./AddGoods.vue?vue&type=style&index=0&id=f7c6b168&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c6b168",
  null
  
)

export default component.exports